import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/fhq-users';
import { ResultState } from '@rootCommon/types/common';
import { FhqUsers } from '@rootCommon/types/fhq';

type Action = ActionType<typeof actions>;
export type FhqUsersState = ResultState<FhqUsers[] | null>;

const initState: FhqUsersState = {
  data: null,
  loading: false,
  error: null,
};

export const fhqUsersReducer = (state = initState, action: Action): FhqUsersState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchFhqUsers.request):
      return { ...state, loading: true };
    case getType(actions.fetchFhqUsers.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchFhqUsers.failure):
      return { ...state, loading: false, error: action.payload };

      // update
    case getType(actions.updateFhqUsers.request):
      return { ...state, loading: true };
    case getType(actions.updateFhqUsers.success):
      return { ...state, loading: false };
    case getType(actions.updateFhqUsers.failure):
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default fhqUsersReducer;
